import script from "./NavBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavBar.vue?vue&type=script&lang=ts&setup=true"

import "./NavBar.vue?vue&type=style&index=0&id=4f156b99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f156b99"]])

export default __exports__